import { useState, useCallback, useEffect, useMemo, useContext } from "react";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./NightCharge.css";
import { ToastContainer, toast } from "react-toastify";
import { SidebarContext } from "../../context/SidebarContext";
import { config } from "../../config.js";
import { useNavigate, useParams } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";

function NightCharge() {
  const navigate = useNavigate()
  const { isSidebar } = useContext(SidebarContext);
  const [loading, setLoading] = useState(false);

  const { city } = useParams();

  const [formData, setFormData] = useState({
    incity: false,
    outstation: false,
    minioutstation: false,
    tenToEleven: "",
    elevenToSix: "",
  });
  const handleToggle = (type) => {
    setFormData((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const getNightCharges = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${config?.backEndBaseUrl}fare/night-charges/${city}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!res.ok) throw new Error();

      const data = await res.json();

      if (data?.status && data?.data) {
        setFormData({
          incity: data.data.incity || false,
          outstation: data.data.outstation || false,
          minioutstation: data.data.minioutstation || false,
          tenToEleven: data.data.tenToEleven || "",
          elevenToSix: data.data.elevenToSix || "",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load night charges");
    } finally {
      setLoading(false);
    }
  }, []);

  const saveNightCharges = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${config?.backEndBaseUrl}fare/night-charges/${city}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify(formData),
        },
      );

      if (!res.ok) throw new Error();

      toast.success("Night charges updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to save");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getNightCharges();
  }, [getNightCharges]);

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : 0 }}
              >
                <div className="main-content-inner">
                  <ToastContainer />
                  <div className="wg-box night-charge-box">
                    <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                      <div className="flex items-center gap-3">
                        <button
                          className="back-btn flex items-center gap-2"
                          onClick={() => navigate(-1)}
                        >
                          <LuArrowLeft size={16} />
                          {/* <span>Back</span> */}
                        </button>

                        <h5 className="fare-heading">Night Charges</h5>
                      </div>
                    </div>

                    {loading ? (
                      <div className="nc-skeleton">
                        {/* Toggle Skeleton */}
                        <div className="nc-skel-title"></div>

                        <div className="nc-skel-toggle-grid">
                          {[1, 2, 3].map((i) => (
                            <div key={i} className="nc-skel-toggle"></div>
                          ))}
                        </div>

                        {/* Charges Skeleton */}
                        <div className="nc-skel-title mt-3"></div>

                        <div className="nc-skel-charge-grid">
                          {[1, 2].map((i) => (
                            <div key={i} className="nc-skel-charge"></div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <>
                        {/* EXISTING UI (no changes) */}
                        <div className="nc-toggle-section">
                          <h6 className="nc-section-title">
                            Enable Night Charges For
                          </h6>

                          <div className="nc-toggle-grid">
                            {["incity", "outstation", "minioutstation"].map(
                              (type) => (
                                <label key={type} className="nc-toggle-card">
                                  <span className="nc-toggle-label">
                                    {type}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={formData[type]}
                                    onChange={() => handleToggle(type)}
                                  />
                                  <span className="nc-toggle-switch"></span>
                                </label>
                              ),
                            )}
                          </div>
                        </div>

                        <div className="charges-section">
                          <h6 className="section-title">Charge Slabs</h6>

                          <div className="charge-grid">
                            <div className="charge-card">
                              <div className="time">10:00 PM - 11:00 PM</div>
                              <input
                                type="number"
                                value={formData.tenToEleven}
                                onChange={(e) =>
                                  handleChange("tenToEleven", e.target.value)
                                }
                                className="charge-input"
                              />
                            </div>

                            <div className="charge-card">
                              <div className="time">11:00 PM - 06:00 AM</div>
                              <input
                                type="number"
                                value={formData.elevenToSix}
                                onChange={(e) =>
                                  handleChange("elevenToSix", e.target.value)
                                }
                                className="charge-input"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-end mt-4">
                          <button
                            className="btn btn-success"
                            onClick={saveNightCharges}
                            disabled={loading}
                          >
                            Save Settings
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NightCharge;
